import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { EnvironmentProviders, inject, Provider, provideEnvironmentInitializer } from "@angular/core";
import { httpInterceptor } from "./http.interceptor";
import { MatSnackBar } from "@angular/material/snack-bar";
import {
  fuseLoadingInterceptor,
  FuseLoadingService,
} from "@fuse/services/loading";

export const provideHttpInterceptor = (): Array<
  Provider | EnvironmentProviders
> => {
  return [
    MatSnackBar /* add snackbar because its used by the interceptor */,
    provideHttpClient(
      withInterceptors([httpInterceptor, fuseLoadingInterceptor]),
    ),
    provideEnvironmentInitializer(() => inject(FuseLoadingService)),
  ];
};
